import BttfAxios from '@features/utils/axios';
import { AxiosResponse } from 'axios';
import { ICompany } from '@market/interfaces/IAssetCompany';

class RecapKeyClass {

  public getKey(investorId: number): Promise<AxiosResponse<{recap_api_key: null | string}>> {
    return BttfAxios.get(` /api/investors/${investorId}/recap_key`,
    (resp) => resp
    );
  }

  public generateKey(investorId: number): Promise<AxiosResponse<{recap_api_key: null | string}>> {
    return BttfAxios.patch(` /api/investors/${investorId}/recap_key`, {},
    (resp) => resp
    );
  }

  public revokeKey(investorId: number) {
    return BttfAxios.delete
    (`/api/investors/${investorId}/recap_key`, {},
    (resp) => resp
    );
  }

  public generateDiscountCoupon(investorId: number, coupon_type: '20' | '50'): Promise<AxiosResponse<{recap_coupon_code: string}>> {
    return BttfAxios.post(`/api/investors/${investorId}/distribute_recap_coupons`, {
      coupon_type:coupon_type
    },
    (resp) => resp
    );
    
  }

  

}
const RecapKeyService = new RecapKeyClass();

export default RecapKeyService;
